import { COLOR, FONT_SIZE, FONT_WEIGHT, Heading as _Heading, Icon as _Icon, mq } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const Heading = styled(_Heading)`
  font-size: ${FONT_SIZE.M}px;
  font-weight: ${FONT_WEIGHT.BOLD};
`;

export const SecRootBannerContainer = styled.section`
  display: grid;
  grid-gap: 8px;
`;

export const ButtonActionWrapper = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border: 1px solid ${COLOR.GRAY200.code};
  border-radius: 8px;
  font-size: ${FONT_SIZE.M}px;

  ${mq.sp} {
    font-size: ${FONT_SIZE.S}px;
  }
`;

export const SpanFont = styled.span`
  font-weight: ${FONT_WEIGHT.BOLD};
`;

export const ParContent = styled.p`
  color: ${COLOR.YELLOW900.code};
  font-weight: ${FONT_WEIGHT.BOLD};
`;

export const ArrowRightIcon = styled(_Icon)`
  padding-left: 16px;
`;
